/**
 * Created by aclerkin on 3/22/17.
 */
import BU from './bankrate-utilities'
BU.targetBlank()
